import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function ServiceCard({ icon: Icon, title, description, href, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
    >
      <Link
        to={href}
        className="block card-luxury p-8 h-full group"
        data-testid={`service-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
      >
        <div className="w-14 h-14 bg-[#d1af6a]/10 flex items-center justify-center mb-6 group-hover:bg-[#d1af6a]/20 transition-colors">
          <Icon className="w-7 h-7 text-[#d1af6a]" />
        </div>
        <h3 className="font-subheading text-xl text-white mb-3 group-hover:text-[#d1af6a] transition-colors">
          {title}
        </h3>
        <p className="text-[#c8c6c4] text-sm leading-relaxed">
          {description}
        </p>
        <div className="mt-6 flex items-center gap-2 text-[#d1af6a] text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
          Mehr erfahren
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </div>
      </Link>
    </motion.div>
  );
}
